import { render, staticRenderFns } from "./SiteLimiter.vue?vue&type=template&id=faf42d1c&scoped=true&"
import script from "./SiteLimiter.vue?vue&type=script&lang=js&"
export * from "./SiteLimiter.vue?vue&type=script&lang=js&"
import style0 from "./SiteLimiter.vue?vue&type=style&index=0&id=faf42d1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf42d1c",
  null
  
)

export default component.exports